// import React from 'react'
import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import CategoryCard from "../../components/CategoryCard";

import { getCategory } from "../../services/getCategory";

const Home = () => {
  const params = useParams();
  const { client_code } = params;

  const [categories, setCategories] = useState([]);
  const [categoriePath, setCategoriePath] = useState([]);

  useEffect(() => {
    getCategoryData();
  }, []);

  const getCategoryData = async () => {
    try {
      const response = await getCategory(client_code);
      if (response?.status) {
        const result = response?.data?.data;
        const catPath = result?.image_path;
        const categories = result?.categories;
        setCategoriePath(catPath);
        setCategories(categories);
      } else {
        console.error("API response status is false:", response);
      }
    } catch (error) {
      console.error("Error in getCategoryData:", error);
      if (error.response) {
        console.error("API Error Response:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    }
  };

  // console.log('client_code =>>>', client_code);

  return (
    <div className="grid grid-cols-12 gap-4">
      {categories?.length > 0 &&
        categories.map((category) => (
          <CategoryCard
            key={category.category_id}
            categoryID={category.category_id}
            title={category.name}
            image={`${categoriePath}/${category.image}`}
            description={category.description}
          />
        ))}
    </div>
  );
};

export default Home;
